import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

const UnsavedZcorDialog = function (props) {
  const { open, onCancel, onConfirm } = props;
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onCancel}>
      <DialogTitle>Cambios de ZCOR sin guardar</DialogTitle>
      <DialogContent>
        <Typography>
          Tienes correcciones de ZCOR unit. que aún no se han guardado. Si continúas, se perderán.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Seguir editando</Button>
        <Button onClick={onConfirm} color="warning" variant="contained">
          Descartar cambios
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedZcorDialog;
